import { ADMIN_DECLINE_REASON } from "./registrationStates";

export type MessageCommunicationConsent =
  | "unknown"
  | "opted_in"
  | "transactional_only"
  | "unsubscribed"
  | "suppressed";

export type MessageAudienceKind = "individual" | "event" | "filtered";

/**
 * Event rosters are used only for transactional event updates. Registration
 * authorizes those operational messages unless an administrator has suppressed
 * delivery. Optional direct and community outreach still requires opt-in.
 */
export function isEligibleForMessageAudience(
  consent: MessageCommunicationConsent | null | undefined,
  audienceKind: MessageAudienceKind,
): boolean {
  return audienceKind === "event"
    ? consent !== "suppressed"
    : consent === "opted_in";
}

/**
 * Whether an event registration receives that event's message campaigns:
 * registered and waitlisted rows do, except a waitlisted row an admin declined.
 * pending_review and every other state do not. Shared by the server recipient
 * gate (filterConsentedMessageAudience) and the campaign composer.
 */
export function isMailableEventRegistration(registration: { registrationState: string; stateChangeReason?: string | null }): boolean {
  if (registration.registrationState === "registered") return true;
  return registration.registrationState === "waitlisted" && registration.stateChangeReason !== ADMIN_DECLINE_REASON;
}
